<template>
<div>
<component v-if="payload" :is="isForm ? 'vue-form' : 'div'" v-on:submit="save" size="xsm" :save-buttons-hidden="readonly">

	<slot></slot>

	<field 
		label="Type" 
		col-class="col-sm-5" 
		:params="{type:'select',options:equipmentTypeOptions}"
		v-model="payload.type_id"
		:readonly="readonly"
		v-on:change="setCustomFieldList">
	</field>

	<field 
		label="Description" 
		col-class="col-sm-5" 
		v-model="payload.description"
		:readonly="readonly"
		:invalid="$store.errorList.description">
	</field>

	<field 
		label="Serial #" 
		col-class="col-sm-5" 
		v-model="payload.serial_num"
		:readonly="readonly"
		:invalid="$store.errorList.serial_num">
	</field>

	<field 
		label="Date Acquired"
		col-class="col-sm-5" 
		:params="{type:'date'}"
		v-model="payload.date_acquired"
		:readonly="readonly"
		:invalid="$store.errorList.date_acquired">
	</field>

	<field 
		label="Equipment Colour" 
		col-class="col-sm-5" 
		v-model="payload.color_hex" 
		:params="{type: 'color'}">
	</field>

	<template v-if="customFieldList && customFieldList.length">

		<hr>

		<template v-for="field in customFieldList">
			<template v-if="field.type == 'select'">
				<field
					col-class="col-sm-5"
					:key="field.label"
					:label="field.label"
					:readonly="readonly"
					:params="{type:field.type,required:field.required,options:optionifyCommaList(field.options)}"
					v-model="customFieldValues[field.label]">
				</field>
			</template>
			<field
				v-else
				col-class="col-sm-5"
				:key="field.label"
				:label="field.label"
				:readonly="readonly"
				:params="{type:field.type,required:field.required}"
				v-model="customFieldValues[field.label]">
			</field>
		</template>
	</template>

	<hr class="mb-4">

	<h4>Next Service</h4>

	<field 
		label="Description" 
		col-class="col-sm-5" 
		v-model="payload.next_service_description"
		:readonly="readonly"
		:invalid="$store.errorList.next_service_description">
	</field>

	<form-group label="Due (date & odo/hrs)"
		col-class="col-sm-5">

		<div class="d-flex flex-row">
			<field 
				:params="{type:'date'}"
				:readonly="readonly"
				v-model="payload.next_service_date"
				:invalid="$store.errorList.next_service_date">
			</field>

			<field 
				:params="{type:'number',placeholder:'mileage or hrs'}"
				:readonly="readonly"
				v-model="payload.next_service_mileage_or_time"
				:invalid="$store.errorList.next_service_mileage_or_time">
			</field>
		</div>

	</form-group>

	<hr class="mb-4">

	<h4>Last Service</h4>

	<field 
		label="Description" 
		col-class="col-sm-5" 
		:readonly="readonly"
		v-model="payload.last_service_description"
		:invalid="$store.errorList.last_service_description">
	</field>

	<form-group label="Done (date & odo/hrs)"
		col-class="col-sm-5">

		<div class="d-flex flex-row">
			<field 
				:params="{type:'date'}"
				:readonly="readonly"
				v-model="payload.last_service_date"
				:invalid="$store.errorList.last_service_date">
			</field>

			<field 
				:params="{type:'number',placeholder:'mileage or hrs'}"
				:readonly="readonly"
				v-model="payload.last_service_mileage_or_time"
				:invalid="$store.errorList.last_service_mileage_or_time">
			</field>
		</div>

	</form-group>

	<hr>

	<button class="btn btn-outline-danger btn-sm" type="button" v-on:click="deleteConfirmModalVisible = true">
		<i class="fa fa-trash"></i>
		Delete Equipment
	</button>

	<button v-if="payload.archived == 0" type="button" class="btn btn-light btn-sm" v-on:click="archiveEquipment">
		<i class="fa fa-archive"></i>
		Archive
	</button>
	<button v-else class="btn btn-light btn-sm" type="button" v-on:click="unarchiveEquipment">
		<i class="fa fa-archive"></i>
		Un-Archive
	</button>

</component>

<comment-thread v-if="payload && 'slug' in payload"
	style="background-color: transparent;"
	:thread-id="'message_thread_id' in payload ? payload.message_thread_id : false"
	:parent-slug="payload.slug"
	parent-model="Equipment"
	:thread-subject-reference="threadSubjectReference">
</comment-thread>

<modal-dialog :modal-visible="deleteConfirmModalVisible"
	title="Delete Equipment"
	confirm-button-text="Yes, Delete"
	button-class="btn-outline-danger"
	v-on:closeModal="deleteConfirmModalVisible = false"
	v-on:confirm="deleteEquipment">
	Are you sure you want to delete this Equipment item and all it's maintenance records?
</modal-dialog>

</div>
</template>
<script type="text/javascript">
import ModalDialog from "../ModalDialog"
import Field from "../Field"
import FormGroup from "@/components/FormGroup"
import CommentThread from "@/components/super_components/CommentThread"
import VueForm from "@/components/VueForm"

export default {
	name: "EquipmentEditForm",
	components: {
		ModalDialog,
		Field,
		FormGroup,
		CommentThread,
		VueForm,
	},
	props: ["record","isForm","equipmentSlug","includes","versionKey"],
	data() {
		return {
			payload: null,
			customFieldValues: {},
			customFieldList: [],
			deleteConfirmModalVisible: false
		}
	},
	computed: {
		threadSubjectReference() {
			if (this.payload && "description" in this.payload)
				return "Equipment: "+this.payload.description
			else
				return "Equipment"
		},
		equipmentTypeOptions() {
			return this.optionify(this.$store.equipmentTypes,"name")
		},
		readonly() {
			if (this.payload.archived == 1)
				return true

			return false
		}
	},
	watch: {
		record() {
			this.payload = this.record
			this.setCustomFields()
			this.setCustomFieldList()
		},
		visible() {
			if (this.record)
				this.payload = this.record
			this.setCustomFields()
			this.setCustomFieldList()
		},
		versionKey() {
			this.fetchData()
		}
	},
	methods: {
		deleteEquipment() {
			let vm = this

			this.postData("Equipment/delete",{id: this.payload.id},true).then(response => {
				if (response.success) {
					vm.deleteConfirmModalVisible = false
					vm.alertSuccess("Equipment deleted!")
					vm.$router.push("/equipment/list")
				}
			})
		},
		archiveEquipment() {
			let vm = this

			let payload = {
				archived: 1,
				id: this.payload.id
			}

			this.postData("Equipment/save",payload,true).then(response => {
				if (response.success) 
					vm.payload.archived = 1
			})
		},
		unarchiveEquipment() {
			let vm = this

			let payload = {
				archived: 0,
				id: this.payload.id
			}

			this.postData("Equipment/save",payload,true).then(response => {
				if (response.success) 
					vm.payload.archived = 0
			})
		},
		optionifyCommaList(list) {
			if (list) {
				let items = list.split(",")

				return items.map(item => {
					return {
						value: item,
						text: item
					}
				})
			}
			else
				return []
		},
		setCustomFields() {
			if (this.record && Object.keys(this.record).length > 0 && this.record.custom_fields_json)
				this.customFieldValues = JSON.parse(this.record.custom_fields_json)
			else if (this.payload && Object.keys(this.payload).length > 0 && this.payload.custom_fields_json)
				this.customFieldValues = JSON.parse(this.payload.custom_fields_json)
			else 
				this.customFieldValues = {}
		},
		setCustomFieldList() {
			let vm = this

			this.$nextTick(() => {

				if (this.$store.equipmentTypes.length > 0) {

					let type = this.$store.equipmentTypes.find(type => {
						if (type.id == vm.payload.type_id)
							return true
					})

					if (type && type.custom_fields_json.length > 2)
						this.customFieldList = JSON.parse(type.custom_fields_json)
					else
						this.customFieldList = []

				}
				else
					this.customFieldList = []

			})
		},
		save() {
			let vm = this

			this.payload.custom_fields_json = JSON.stringify(this.customFieldValues)

			this.saveRecord("Equipment",this.payload,response => {
				vm.alertSaved("Equipment saved!")
				vm.$emit("closeModal")
				vm.$emit("modelChanged")

				if (vm.equipmentSlug == 'new')
					vm.$router.push("/equipment/edit/"+response.data.slug+"/log")
			})
		},
		closeModal() {
			this.$emit("closeModal")
		},
		fetchData() {
			let vm = this

			vm.spinner(true)

			let promises = [
				this.fetchModel("EquipmentType")
			]

			if (!this.record && this.equipmentSlug && this.equipmentSlug != 'new') {
				let params = {}
				if (this.includes)
					params.include = this.includes
				promises.push(this.getJSON("Equipment/find/"+this.equipmentSlug, params))
			}

			Promise.all(promises).then(responses => {

				if (responses.length > 1 && responses[1].success) {
					vm.payload = responses[1].data
					vm.setCustomFields()
					vm.setCustomFieldList()

					vm.$emit("equipmentFetched",responses[1].data)
				}

				vm.spinner(false)
			})
		}
	},
	created() {
		if (this.record)
			this.payload = this.record

		if (this.equipmentSlug == 'new')
			this.payload = {}

		this.fetchData()
		this.setCustomFields()
	}
}
</script>